/* eslint-disable no-unused-vars */
/* eslint-disable react/prop-types */

import {
	Dialog,
	DialogContent,
	DialogTitle,
	Button,
	DialogActions,
	Box,
	TextField
} from "@material-ui/core";
import i18n from "i18next";
import React, { useEffect, useState } from "react";
import lod_ from "lodash";
import { useDispatch, useSelector } from "react-redux";
import cockpitActions from "../../../redux/actions/cockpitActions";

/**
 * Form specific: Build input with type and options given
 */
function FormBriefDraft({ code, actionObject, handleClose, handleSubmit }) {
	const [open, setOpen] = React.useState(true);
	const [brief, setBrief] = useState("");
	const dispatch = useDispatch();

	const { selectedConversation } = useSelector(state => state.cockpit);
	const userStatus = useSelector(state => state.userStatus);

	/** On load, set default content brief if any pathDictionary 	*/
	useEffect(() => {
		if (
			!lod_.isNil(actionObject?.config?.pathDictionary) &&
			!lod_.isEmpty(actionObject?.config?.pathDictionary)
		) {
			const defaultContent = lod_.get(
				selectedConversation || {},
				actionObject.config.pathDictionary,
				""
			);
			setBrief(defaultContent);
		}
	}, []);

	/** On submit, send payload with brief content and other action to set in this process */
	const handleActionDialogSubmit = () => {
		if (
			!lod_.isNil(actionObject?.config?.pathDictionary) &&
			!lod_.isEmpty(actionObject?.config?.pathDictionary)
		) {
			const data = {
				header: {
					assistantID: selectedConversation?.header?.assistantID,
					fID: selectedConversation?.header?.fID
				},
				payload: {}
			};

			data.payload[actionObject.config.pathDictionary] = brief;

			dispatch(cockpitActions.launchActionFrontV2("updateConvDictionaryPartial", data));
		}

		handleSubmit(
			{
				briefContent: brief
			},
			code,
			actionObject
		);
	};

	/**
	 * Get title of the pop-up depending on the actionName if exists, else default title
	 */
	const getActionPopUpTitle = () => {
		const language = userStatus?.auth?.user?.language?.toUpperCase();
		if (!lod_.isEmpty(actionObject?.actionName)) {
			if (!lod_.isNil(language) && !lod_.isEmpty(actionObject.actionName[language])) {
				return actionObject.actionName[language];
			} else {
				const byDefault =
					actionObject.actionName.EN ??
					Object.values(actionObject.actionName)[0] ??
					i18n.t("actionEvent.briefActionTitle");
				return byDefault;
			}
		}

		return i18n.t("actionEvent.briefActionTitle");
	};

	return (
		<div>
			<Dialog
				fullWidth={true}
				onClose={handleClose}
				maxWidth={"sm"}
				open={open}
				aria-labelledby="form-dialog-title"
			>
				<DialogTitle id="form-dialog-title">{getActionPopUpTitle()}</DialogTitle>
				<DialogContent dividers>
					<Box>
						<TextField
							fullWidth
							minRows={6}
							maxRows={6}
							multiline
							id="standard-required"
							name={`briefActionContent`}
							label={i18n.t("actionEvent.briefActionContent")}
							variant="outlined"
							value={brief}
							onChange={e => setBrief(e.target.value)}
						/>
					</Box>
				</DialogContent>
				<DialogActions>
					<Button onClick={handleClose} style={{ margin: "2%" }} color="secondary">
						{i18n.t("CD.cancel")}
					</Button>
					<Button
						onClick={() => handleActionDialogSubmit()}
						style={{ margin: "2%" }}
						color="primary"
						disabled={lod_.isEmpty(brief)}
					>
						{i18n.t("CD.validate")}
					</Button>
				</DialogActions>
			</Dialog>
		</div>
	);
}

export default FormBriefDraft;
